import MasterCrudPage from "../../components/MasterCrudPage";
import { specializationApi } from "../../api/masterApi";

export default function Specialization() {
  return (
    <MasterCrudPage
      title="Specialization Master"
      description="Add specializations and manage them below."
      idKey="specialization_id"
      api={specializationApi}
      listLabel="specializations"
      hasImage
      imageField="specialization_image"
      fields={[
        {
          name: "specialization_name",
          label: "Specialization Name",
          type: "text",
          required: true,
          placeholder: "e.g. Vastu Consultation",
        },
        {
          name: "specialization_image",
          label: "Specialization Image",
          type: "file",
        },
        {
          name: "description",
          label: "Description",
          type: "textarea",
          fullWidth: true,
        },
        { name: "status", label: "Status", type: "checkbox" },
      ]}
      columns={[
        { key: "specialization_id", label: "ID" },
        { key: "specialization_name", label: "Specialization" },
        { key: "specialization_image", label: "Image", type: "image" },
        { key: "status", label: "Status", type: "status" },
      ]}
    />
  );
}
